<cmn-focus-on-field ></cmn-focus-on-field>

<main class="padding-bottom-105 efast-pad-mobile-right" id="main-content">
  <div class="grid-row grid-gap">
    <div class="tablet:grid-col-10 tablet:grid-offset-1">
      <div class="">

        <h1>{{fieldLabels['title']}}</h1>
        <efast-modal-processing></efast-modal-processing>
        <efast-modal-not-found></efast-modal-not-found>
        <efast-modal-error></efast-modal-error>
        <div class="margin-y-1">
          <button class="usa-button" type="button" (click)='toggleFilter()' >
            <span>{{isFilterShown ? fieldLabels['hideFiltersBtn']  : fieldLabels['showFiltersBtn'] }}
            </span>
          </button>
          <a class="usa-link usa-color-text-visited" href="{{helpLink}}" target="_blank">{{fieldLabels['helpLink']}}</a>
        </div>

        <p>
          {{fieldLabels['note1']}}
        </p>
        <p>
          {{fieldLabels['note3']}}
        </p>
        <p>
          {{fieldLabels['DDNote1']}}
          <a class="usa-link usa-color-text-visited" href="{{AFSDDLink}}" target="_blank">{{fieldLabels['AFSDDLink']}}</a>
          {{fieldLabels['DDNote2']}}
          <a class="usa-link usa-color-text-visited" href="{{Form5500SeriesDDLink}}" target="_blank">{{fieldLabels['Form5500SeriesDDLink']}}</a>
          {{fieldLabels['DDNote3']}}
        </p>
        <p>
          {{fieldLabels['note2']}}
        </p>

        <div class="mainContainer grid-row grid-gap-lg">
          <div class="filterContainer grid-col-auto paddingBot2">
            <efast-filter [isFilterShown]="isFilterShown" [events]="eventsSubject.asObservable()"></efast-filter>
          </div>

          <div class="searchContainer grid-col-fill paddingBot2">
            <gd-field-dropdown gdFieldId="categoryType" [gdShowFlag]="true"
              gdAddClass="searchDropDown" gdDisableHook="" [(gdModel)]="categoryType"
              [gdDisabled]="false" [gdShowOnChange]="'categoryType'" (gdValueChange)="onCategoryTypeChanged()"
              [gdOptions]="fieldOptions['categoryType']">
            </gd-field-dropdown>


            <div class="usa-search usa-search--big displayFlex">
              <input aria-label="search field input" class="usa-input grid-col-fill" id="search-field" type="search" [(ngModel)]="searchField" (keyup.enter)="go()" name="search">
              <button class="usa-button" type="submit" (click)='go()'  >
                <span class="usa-search__submit-text">{{this.fieldLabels['search']}}</span>
              </button>
            </div>

            <efast-breadcrumb [events]="eventsSubject.asObservable()"></efast-breadcrumb>
            <div class="margin-y-1">
              <span tabindex="0" id='resultsCntID' class="usa-button  usa-button--disabled bg-base">
                <div>
                  <span [innerHTML]="this.fieldLabels['resultsCnt']"></span>
                  &nbsp;
                  <span [innerHTML]="hitsCnt"></span>

                  @if (isMaxCntAbove) {
                    <span>&nbsp;</span>
                  }
                  @if (isMaxCntAbove) {
                    <span [innerHTML]="this.fieldLabels['resultsMaxMsg']"> </span>
                  }
                </div>
              </span>
              <button class="usa-button  usa-button--active" type="submit" (click)='exportCsv()' >
                <div>
                  <span [innerHTML]="this.fieldLabels['exportCsvBtn']"></span>
                </div>
              </button>
              <button class="usa-button  usa-button--active" type="submit" (click)='resetForm()'>
                <div>
                  <span [innerHTML]="this.fieldLabels['resetFormBtn']"></span>
                </div>
              </button>
            </div>
            <efast-paginator [efastIsShown]="isResultsShown" [events]="eventsSubject"></efast-paginator>
            <efast-table-sortable [efastHits]="efastHits"  [efastIsShown]="isResultsShown"></efast-table-sortable>
            <efast-paginator [efastIsShown]="isResultsShown" [events]="eventsSubject"></efast-paginator>
            @if (isDCGRowExisting) {
              <div class="margin-y-1">
                <span style="color:blue;font-weight:bold">{{fieldLabels['noteDCG1A']}} </span>
                {{fieldLabels['noteDCG1']}}
                <p>
                  {{fieldLabels['noteDCG2']}}
                  <span style="font-weight:bold">
                    {{fieldLabels['noteDCG2A']}}
                    <a class="usa-link usa-color-text-visited" href="{{helpLink}}" target="_blank">
                      {{fieldLabels['noteDCG2Link']}}
                    </a>
                    {{fieldLabels['noteDCG2B']}}
                    <i>
                      {{fieldLabels['noteDCG2C']}}
                    </i>
                    {{fieldLabels['noteDCG2D']}}
                  </span>
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
